import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';
import { User, UserRoles } from '../../shared/core/state/users/models';

@Component({
  selector: 'black-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css'],
  standalone: false,
})
export class UserDashboardComponent implements OnInit {
  private store = inject<Store<State>>(Store);

  user: Partial<User> | null = null;

  ngOnInit(): void {
    this.store
      .select((state) => state.users.user)
      .subscribe((user) => (this.user = user));
  }

  get fullName() {
    if (this.user?.name) {
      return this.user?.name?.firstName + ' ' + this.user?.name?.lastName;
    }
    return 'John Doe';
  }

  get lastName() {
    if (this.user?.name) {
      return this.user?.name?.lastName;
    }
    return 'John';
  }

  get isTutor() {
    return this.user?.role === UserRoles.INSTRUCTOR;
  }
}
